module.exports = __webpack_public_path__ + "static/media/TEMPLATE6.58c276fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adtemplates/TEMPLATE6.jpg
// module id = 1472
// module chunks = 1